import { render, staticRenderFns } from "./OMultiCheckbox.vue?vue&type=template&id=5d4d1c07&scoped=true&"
import script from "./OMultiCheckbox.vue?vue&type=script&lang=js&"
export * from "./OMultiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./OMultiCheckbox.vue?vue&type=style&index=0&id=5d4d1c07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d1c07",
  null
  
)

export default component.exports